import { decodeJwt } from "../../utils/jwt/decode-jwt";
import { sleep } from "../../utils/sleep";
import {
    JwtToken,
    TokenVerification,
    VerificationResponse,
} from "./gated-content-types";

const localStorageKey = "trumpf.ux.gatedContentTokens";

export const getLocalStorageTokens = function (): string[] {
    return localStorage.getItem(localStorageKey) !== null
        ? JSON.parse(localStorage.getItem(localStorageKey))
        : [];
};

export const removeFromLocalStorage = function (token: string): void {
    const tokens = getLocalStorageTokens();
    const index = tokens.indexOf(token);
    if (index > -1) {
        tokens.splice(index, 1);
        localStorage.setItem(localStorageKey, JSON.stringify(tokens));
    }
};

export const addToLocalStorage = function (token: string) {
    const tokens = getLocalStorageTokens();
    if (tokens.includes(token)) return;
    tokens.push(token);
    localStorage.setItem(localStorageKey, JSON.stringify(tokens));
};

export const verifyToken = async function (
    token: string,
    verifyTokenUrl: string
): Promise<TokenVerification> {
    const isMockData = verifyTokenUrl.includes("/mock-data/");
    const config = isMockData
        ? {
              method: "GET",
          }
        : {
              method: "POST",
              headers: {
                  "Content-Type": "text/plain",
              },
              body: token,
          };
    // send token to server for verification
    return fetch(verifyTokenUrl, config)
        .then(sleep(isMockData ? 1000 : 0)) // simulate network delay for storybook
        .then((response) => response.json())
        .then((response: VerificationResponse) => {
            return {
                token,
                result: response.result,
            };
        })
        .catch(() => {
            return {
                token,
                result: "error",
            };
        });
};

export const persistResultsInLocalStorage = function (
    results: TokenVerification[]
): void {
    results.forEach(({ token, result }) => {
        const decodedToken = decodeJwt<JwtToken>(token);
        if (result === "valid" && decodedToken.persist) {
            addToLocalStorage(token);
        }
        if (result === "blacklisted") {
            removeFromLocalStorage(token);
        }
    });
};
